import { create } from "zustand";
import { persist } from "zustand/middleware";

import { UsePaginationFetchMoreProps } from "components/Table/Pagination/types";
import { SearchQueryRequestedPage } from "types/generated";

type TofuWorkspacesStore = {
  rowsPerPage: number;
  cursor: string | null;
  requestedPage: SearchQueryRequestedPage;
  onFetchItems: (props: UsePaginationFetchMoreProps) => void;
  resetCursor: () => void;
};

const useTofuWorkspacesStore = create<TofuWorkspacesStore>()(
  persist(
    (set) => ({
      rowsPerPage: 50,
      cursor: null,
      requestedPage: SearchQueryRequestedPage.First,
      onFetchItems: (props: UsePaginationFetchMoreProps) =>
        set({ cursor: props.cursor, requestedPage: props.requestedPage }),
      resetCursor: () => set({ cursor: null, requestedPage: SearchQueryRequestedPage.First }),
    }),
    {
      name: "tofu-workspaces-store",
      partialize: (state) => ({
        rowsPerPage: state.rowsPerPage,
      }),
    }
  )
);

export default useTofuWorkspacesStore;
